import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SeoService } from './seo.service';

@NgModule({
  providers: [SeoService],
  imports: [HttpClientModule],
})
export class SeoModule {}
